import { Breadcrumbs } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { notifySet } from '../../Services/Actions/CommonActions';
import { getFields, STATUS_MSG } from '../../Services/config/globals';
import { uploadImages } from '../../Services/Utils/CommonApis';
import { addCategorySubmit } from '../../Services/Utils/ServiceProviderApis';
import CategoryForm from './CategoryForm';

export default function AddCategory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [logoImage, setLogoImage] = useState([]);

  const handleChangeLogo = ({ fileList: newFileList }) => {
    setLogoImage(newFileList);
  };

  const logoImages = getFields(logoImage, 'originFileObj');

  const onButtonClick = async (formData) => {
    uploadImages({ file: logoImages[0] }).then((res) => {
      if (res.status === true) {
        const data = {
          name: formData.categoryName,
          keyword: formData.categoryName,
          bannerFileView: {
            fileId: res.view?.fileId
          },
          order: 2
        };
        addCategorySubmit(data).then((resp) => {
          if (resp.status === true) {
            navigate('/categories');
          } else if (resp.status === -1) {
            dispatch(notifySet({ type: 'error', message: resp.message }));
          }
        });
      } else {
        dispatch(notifySet({ type: 'error', message: STATUS_MSG.uploadLogo }));
      }
    });
  };
  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/categories">Categories</Link>
          <Link to="#">Add Category</Link>
        </Breadcrumbs>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <CategoryForm
            onButtonClick={onButtonClick}
            buttonSaveText="Save"
            logoImage={logoImage}
            handleChangeLogo={handleChangeLogo}
            categoryText="Add Category"
            action="add"
          />
        </div>
      </div>
    </div>
  );
}
